import React from 'react';
import Spinner from 'shared/components/Spinner';
import 'assets/sportsbook/styles/spinner.scss';

/**
 * Loader that shows Spinner when status is true (replaces caribe7/lib/helpers/loader).
 */
export default function DynamicSpinner({ status }: { status?: boolean }) {
  if (status) {
    return <Spinner cover />;
  }
  return <div />;
}
